import React, { useState, useEffect } from 'react'
import { Chart } from 'primereact/chart';
import "./Dashboard.scss";
import CheckIcon from '../../assets/images/check.png';
import InfoIcon from '../../assets/images/info.png';
import { AutoComplete } from 'primereact/autocomplete';
import { CountryService } from "./CountryService";
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import { Calendar } from 'primereact/calendar';

const Dashboard = () => {
    const [dates, setDates] = useState(null);
    // auto start
    const [countries, setCountries] = useState([]);
    const [selectedCountries, setSelectedCountries] = useState(null);
    const [filteredCountries, setFilteredCountries] = useState(null);

    const search = (event) => {
        // Timeout to emulate a network connection
        setTimeout(() => {
            let _filteredCountries;

            if (!event.query.trim().length) {
                _filteredCountries = [...countries];
            }
            else {
                _filteredCountries = countries.filter((country) => {
                    return country.name.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCountries(_filteredCountries);
        }, 250);
    }

    useEffect(() => {
        CountryService.getCountries().then((data) => setCountries(data));
    }, []);
    // auto end
    // Sales Pipeline bar chart start
    const [salesPipelineChartData, setSalesPipelineChartData] = useState({});
    const [salesPipelineChartOptions, setSalesPipelineChartOptions] = useState({});
    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const surfaceBorder = documentStyle.getPropertyValue('#fff');
        const data = {
            labels: ['Quote Under Preparation', 'Quote Submitted', 'Quote Accepted', 'Submittal Approved', 'Order Expected'],
            datasets: [
                {
                    label: 'Value',
                    backgroundColor: '#799EF7',
                    borderColor: '#799EF7',
                    data: [20, 40, 60, 80, 100]
                },
                {
                    label: 'Number',
                    backgroundColor: '#EF7D7C',
                    borderColor: '#EF7D7C',
                    data: [28, 48, 40, 19, 86]
                },
            ]
        };
        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        color: "#fff"
                    },
                    position: 'bottom',
                    align: "middle"
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#fff",
                    },
                    grid: {
                        display: false,
                        drawBorder: false
                    }
                },
                y: {
                    ticks: {
                        color: "#fff"
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                },
                z: {
                    position: "right",
                    align: "middle",
                    ticks: {
                        color: "#fff"
                    },
                    grid: {
                        color: "#7B99B4",
                        drawBorder: false
                    }
                }
            }
        };

        setSalesPipelineChartData(data);
        setSalesPipelineChartOptions(options);
    }, []);
    // Sales Pipeline bar chart end
    // Product bar chart start
    const [productChartData, setProductChartData] = useState({});
    const [productChartOptions, setProductChartOptions] = useState({});
    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const surfaceBorder = documentStyle.getPropertyValue('#fff');
        const data = {
            labels: ['Life Safety Dampers', 'Diffusers', 'Louvers', 'Noise Control', 'Air Terminal Units', 'Grilles & Registers', 'Air Control Dampers'],
            datasets: [
                {
                    label: 'Value',
                    backgroundColor: '#799EF7',
                    borderColor: '#799EF7',
                    data: [50, 100, 150, 200, 250, 300, 350]
                },
                {
                    label: 'Number',
                    backgroundColor: '#6CD485',
                    borderColor: '#6CD485',
                    data: [28, 48, 40, 19, 86, 34, 65]
                },
            ]
        };
        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        color: "#fff"
                    },
                    position: 'bottom',
                    align: 'right'
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#fff",
                    },
                    grid: {
                        display: false,
                        drawBorder: false
                    }
                },
                y: {
                    ticks: {
                        color: "#fff"
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                },
                z: {
                    position: "right",
                    align: "middle",
                    ticks: {
                        color: "#fff"
                    },
                    grid: {
                        color: "#7B99B4",
                        drawBorder: false
                    }
                }
            }
        };

        setProductChartData(data);
        setProductChartOptions(options);
    }, []);
    // Product bar chart end
    // Ratio Doughnut Chart start
    const [ratioDoughnutChartData, setRatioDoughnutChartData] = useState({});
    const [ratioDoughnutChartOptions, setRatioDoughnutChartOptions] = useState({});

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const data = {
            labels: ['Converted Quotes', 'Unconverted Quotes'],
            color: '#fff',
            datasets: [
                {
                    data: [300, 100],
                    backgroundColor: ['#C61E88', '#9181A6'],
                }
            ]
        };
        const options = {
            cutout: '60%',
            aspectRatio: 1,
            plugins: {
                legend: {
                    labels: {
                        color: '#fff'
                    },
                    position: 'bottom',
                    align: "middle"
                }
            }
        };
        setRatioDoughnutChartData(data);
        setRatioDoughnutChartOptions(options);
    }, []);
    // Ratio Doughnut Chart end
    // group Pie chart start
    const [groupChartData, setGroupChartData] = useState({});
    const [groupChartOptions, setGroupChartOptions] = useState({});

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const data = {
            labels: ['Life Safety Dampers - QR 150 K', 'Diffusers - QR 230 K', 'Louvers - QR 308 K', 'Noise Control - QR 210 K', 'Air Terminal Units - QR 180 K', 'Grilles & Registers - QR 220 K', 'Air Control Dampers - QR 53 K'],
            datasets: [
                {
                    data: [16, 4, 11, 17, 23, 16, 13],
                    backgroundColor: ['#ff9b9b', '#4ba650', '#7f8bc1', '#c8ad4a', '#c68082', '#9e186d', '#925bb9'],
                }
            ]
        }
        const options = {
            plugins: {
                legend: {
                    display: false,
                }
            }
        };

        setGroupChartData(data);
        setGroupChartOptions(options);
    }, []);
    // group Pie chart end
    return (
        <section className='dashboard-sec'>
            <div className="container-fluid">
                <div className="row search-row pt-1">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12"></div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                        <div className='d-block d-sm-flex justify-content-end gap-1'>
                            <div className='mb-2 mb-sm-0'>
                                <AutoComplete className='form-control' field="name" value={selectedCountries} suggestions={filteredCountries} completeMethod={search} onChange={(e) => setSelectedCountries(e.value)} placeholder="🔍 Distributor" />
                            </div>
                            <div>
                                <AutoComplete className='form-control' field="name" value={selectedCountries} suggestions={filteredCountries} completeMethod={search} onChange={(e) => setSelectedCountries(e.value)} placeholder="🔍 Sales Person" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 left-column pr-3 pr-lg-1">
                        <div className='row'>
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-2 pr-3 pr-lg-1">
                                <div className='card ytd-card'>
                                    <div className='card-body justify-content-center justify-content-sm-start'>
                                        <div className='ml-20px'>
                                            <h3>Order Booking</h3>
                                            <h2><span className='mr-2'>QR</span>2.5 M</h2>
                                            <h4>YTD</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-2 pl-3 pl-lg-1">
                                <div className='card mtd-card'>
                                    <div className='card-body justify-content-center justify-content-sm-start'>
                                        <div className='ml-20px'>
                                            <h3>Order Booking</h3>
                                            <h2><span className='mr-2'>QR</span>570 K</h2>
                                            <h4>MTD</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-2 pr-3 pr-lg-1">
                                <div className='card order-conversion-ratio-card'>
                                    <div className='card-header'>
                                        <h2>Order Conversion Ratio </h2>
                                    </div>
                                    <div className='card-body pt-0'>
                                        <div className='row'>
                                            <div className='col-12 my-auto'>
                                                <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
                                                    <div className='total-quotes'>
                                                        <h6>6 K</h6>
                                                        <p>Total Quotes</p>
                                                    </div>
                                                    <div className='total-quotes'>
                                                        <h6>3.6 K</h6>
                                                        <p>Converted Quotes</p>
                                                    </div>
                                                    <div className='total-quotes'>
                                                        <h6>2.4 K</h6>
                                                        <p>Lost Quotes</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-12'>
                                                <div className='d-flex justify-content-center d-lg-block'>
                                                    <Chart type="doughnut" data={ratioDoughnutChartData} options={ratioDoughnutChartOptions} />
                                                    <div className='converted-quotes'>
                                                        <h5>60%</h5>
                                                        <h6>Conversion Ratio</h6>
                                                        <img src={CheckIcon} alt="Check Icon" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-2 pl-3 pl-lg-1">
                                <div className='card order-conversion-ratio-card'>
                                    <div className='card-header'>
                                        <h2>Order Conversion Ratio </h2>
                                    </div>
                                    <div className='card-body pt-0'>
                                        <div className='row'>
                                            <div className='col-12 my-auto'>
                                                <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
                                                    <div className='total-quotes'>
                                                        <h6>6 K</h6>
                                                        <p>Total Projects</p>
                                                    </div>
                                                    <div className='total-quotes'>
                                                        <h6>3.6 K</h6>
                                                        <p>Converted Projects</p>
                                                    </div>
                                                    <div className='total-quotes'>
                                                        <h6>2.4 K</h6>
                                                        <p>Lost Projects</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-12'>
                                                <div className='d-flex justify-content-center d-lg-block'>
                                                    <Chart type="doughnut" data={ratioDoughnutChartData} options={ratioDoughnutChartOptions} />
                                                </div>
                                                <div className='converted-quotes'>
                                                    <h5>60%</h5>
                                                    <h6>Conversion Ratio</h6>
                                                    <img src={CheckIcon} alt="Check Icon" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 mb-2'>
                                <div className='card new-leads-card'>
                                    <div className='card-header'>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <h2>New Leads / Assigned projects</h2>
                                            <div class="dropdown">
                                                <button class="btn" type="button" data-toggle="dropdown" aria-expanded="false" data-bs-auto-close="inside">
                                                    <span class="material-symbols-rounded">
                                                        filter_list
                                                    </span>
                                                </button>
                                                <div class="dropdown-menu">
                                                    <div class="accordion" id="accordionExample">
                                                        <div class="card">
                                                            <div class="card-header" id="headingOne">
                                                                <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                                    <i className='fas fa-search mr-2'></i>Product Family <i className='fas fa-angle-down'></i>
                                                                </button>
                                                            </div>

                                                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                                                <div class="card-body">
                                                                    Some placeholder content for the first accordion panel. This panel is shown by default, thanks to the <code>.show</code> class.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="card">
                                                            <div class="card-header" id="headingTwo">
                                                                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                                    <i className='fas fa-search mr-2'></i> Quote Status <i className='fas fa-angle-down'></i>
                                                                </button>
                                                            </div>
                                                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                                                <div class="card-body">
                                                                    Some placeholder content for the second accordion panel. This panel is hidden by default.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='card-body pt-0'>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <div className='table-responsive'>
                                                    <table class="table table-borderless table-sm m-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Type</th>
                                                                <th>Date</th>
                                                                <th>Project</th>
                                                                <th>Customer</th>
                                                                <th>Quote Value(QR)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>Quotation</td>
                                                                <td>19/11/2024</td>
                                                                <td>Sidra Medical and Research Center</td>
                                                                <td>Chic Boutique.Ltd</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Quotation</td>
                                                                <td>19/11/2024</td>
                                                                <td>Sidra Medical and Research Center</td>
                                                                <td>Chic Boutique.Ltd</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Quotation</td>
                                                                <td>19/11/2024</td>
                                                                <td>Sidra Medical and Research Center</td>
                                                                <td>Chic Boutique.Ltd</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Quotation</td>
                                                                <td>19/11/2024</td>
                                                                <td>Sidra Medical and Research Center</td>
                                                                <td>Chic Boutique.Ltd</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Quotation</td>
                                                                <td>19/11/2024</td>
                                                                <td>Sidra Medical and Research Center</td>
                                                                <td>Chic Boutique.Ltd</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 mb-2'>
                                <div className='card top-opportunities-card'>
                                    <div className='card-header'>
                                        <h2>Top 15 Opportunities</h2>
                                    </div>
                                    <div className='card-body pt-0'>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <div className='table-responsive'>
                                                    <table class="table table-borderless table-sm m-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Project</th>
                                                                <th>Number of Quotes</th>
                                                                <th>Value(QR)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>Hilton Salwa Beach resort</td>
                                                                <td>5</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>The Pearl Gateway Towers</td>
                                                                <td>8</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>The View Hospital</td>
                                                                <td>3</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>The View Hospital</td>
                                                                <td>3</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>The View Hospital</td>
                                                                <td>3</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>The View Hospital</td>
                                                                <td>3</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>The View Hospital</td>
                                                                <td>3</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>The View Hospital</td>
                                                                <td>3</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>The View Hospital</td>
                                                                <td>3</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>The View Hospital</td>
                                                                <td>3</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>The View Hospital</td>
                                                                <td>3</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>The View Hospital</td>
                                                                <td>3</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>The View Hospital</td>
                                                                <td>3</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>The View Hospital</td>
                                                                <td>3</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>The View Hospital</td>
                                                                <td>3</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 right-column pl-3 pl-lg-1">
                        <div className='row'>
                            <div className='col-12 mb-2'>
                                <div className='card product-family-wise-quotation-card'>
                                    <div className='card-header'>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <h2>Product Family Wise Quote Values</h2>
                                            <div class="dropdown">
                                                <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                                                    <span class="material-symbols-rounded">
                                                        filter_list
                                                    </span> By Stages
                                                </button>
                                                <div class="dropdown-menu">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" value="" id="quoteUnderPreparation" />
                                                        <label class="form-check-label" for="quoteUnderPreparation">
                                                            Quote Under Preparation
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" value="" id="quoteSubmitted" />
                                                        <label class="form-check-label" for="quoteSubmitted">
                                                            Quote Submitted
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" value="" id="quoteAccepted" />
                                                        <label class="form-check-label" for="quoteAccepted">
                                                            Quote Accepted
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" value="" id="submittalApproved" />
                                                        <label class="form-check-label" for="submittalApproved">
                                                            Submittal Approved
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" value="" id="orderExpected" />
                                                        <label class="form-check-label" for="orderExpected">
                                                            Order Expected
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" value="" id="orderReceived" />
                                                        <label class="form-check-label" for="orderReceived">
                                                            Order Received
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='card-body pt-0'>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <Chart type="bar" data={productChartData} options={productChartOptions} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12 mb-2">
                                <div className='card sales-pipeline-card'>
                                    <div className='card-header'>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <div className='d-flex justify-content-between'>
                                                    <div>
                                                        <h6>Sales Pipeline</h6>
                                                        <p>By Stage</p>
                                                    </div>
                                                    <div className='d-flex justify-content-between gap-1'>
                                                        <div>
                                                            <h4><span className='mr-2'>QR</span>223 K</h4>
                                                            <h5>Value of Quotes</h5>
                                                        </div>
                                                        <div className='text-right'>
                                                            <h4>140</h4>
                                                            <h5>Number of Projects</h5>
                                                        </div>
                                                        <div className='text-right'>
                                                            <h4>940</h4>
                                                            <h5>Number of Quotes</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='card-body pt-0'>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <Chart type="bar" data={salesPipelineChartData} options={salesPipelineChartOptions} height="250px" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 mb-2'>
                                <div className='card group-wise-distribution-card'>
                                    <div className='card-header'>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <h2>Product Family Wise / Group wise Forecast Distribution</h2>
                                            <Calendar value={dates} onChange={(e) => setDates(e.value)} selectionMode="range" readOnlyInput hideOnRangeSelection placeholder='From-To' showIcon />
                                        </div>
                                    </div>
                                    <div className='card-body pt-0'>
                                        <div className='row'>
                                            <div className='col-6'>
                                                <div className='d-flex justify-content-center w-100'>
                                                    <Chart type="pie" data={groupChartData} options={groupChartOptions} />
                                                </div>
                                            </div>
                                            <div className='col-6 my-auto'>
                                                <div className='d-flex gap-1'>
                                                    <div className='squre green-squre'></div>
                                                    <h6>Life Safety Dampers - QR 150 K</h6>
                                                </div>
                                                <div className='d-flex gap-1'>
                                                    <div className='squre green-squre'></div>
                                                    <h6>Diffusers - QR 230 K</h6>
                                                </div>
                                                <div className='d-flex gap-1'>
                                                    <div className='squre yellow-squre'></div>
                                                    <h6>Louvers - QR 308 K</h6>
                                                </div>
                                                <div className='d-flex gap-1'>
                                                    <div className='squre orange-squre'></div>
                                                    <h6>Noise Control - QR 210 K</h6>
                                                </div>
                                                <div className='d-flex gap-1'>
                                                    <div className='squre red-squre'></div>
                                                    <h6>Air Terminal Units - QR 180 K</h6>
                                                </div>
                                                <div className='d-flex gap-1'>
                                                    <div className='squre green-squre'></div>
                                                    <h6>Grilles & Registers - QR 220 K</h6>
                                                </div>
                                                <div className='d-flex gap-1'>
                                                    <div className='squre yellowgreen-squre'></div>
                                                    <h6>Air Control Dampers - QR 53 K</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 mb-2'>
                                <div className='card forecast-table-card'>
                                    <div className='card-header'>
                                        <div className='row'>
                                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-2">
                                                <div className='card mb-2 total-forecast-card'>
                                                    <div className='card-body justify-content-center justify-content-sm-start'>
                                                        <div>
                                                            <h3>Forecast</h3>
                                                            <h2><span className='mr-2'>QR</span>3,000 K</h2>
                                                            <h4>Total</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-2">
                                                <div className='card mb-2 this-month-forecast-card'>
                                                    <div className='card-body justify-content-center justify-content-sm-start'>
                                                        <div>
                                                            <h3>Forecast</h3>
                                                            <h2><span className='mr-2'>QR</span>700 K</h2>
                                                            <h4>This Month</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <div>
                                                        <h6>Forecast</h6>
                                                    </div>
                                                    <div className='d-flex justify-content-between gap-3'>
                                                        <div class="dropdown"><button class="btn dropdown-toggle" type="button" data-toggle="dropdown"
                                                            aria-expanded="false"><span class="material-symbols-rounded">filter_list </span>Product Family </button>
                                                            <div class="dropdown-menu">
                                                                <div class="form-check"><input class="form-check-input" type="checkbox" value="" id="defaultCheck1" /><label
                                                                    class="form-check-label" for="defaultCheck1">Quote Under Preparation </label></div>
                                                                <div class="form-check"><input class="form-check-input" type="checkbox" value="" id="defaultCheck1" /><label
                                                                    class="form-check-label" for="defaultCheck1">Quote Submitted </label></div>
                                                                <div class="form-check"><input class="form-check-input" type="checkbox" value="" id="defaultCheck1" /><label
                                                                    class="form-check-label" for="defaultCheck1">Quote Accepted </label></div>
                                                                <div class="form-check"><input class="form-check-input" type="checkbox" value="" id="defaultCheck1" /><label
                                                                    class="form-check-label" for="defaultCheck1">Submittal Approved </label></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='card-body forecast-table-card-body pt-0'>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <div className='table-responsive'>
                                                    <table class="table table-borderless table-sm m-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Project</th>
                                                                <th>Value(QR)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>Doha Exhibition and Convention Center</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Doha Oasis</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Qatar Petroleum District</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Doha Exhibition and Convention Center</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Doha Oasis</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Qatar Petroleum District</td>
                                                                <td>40 K</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Dashboard